import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=055e7ed2&"
import script from "./SidebarMenu.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports